import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
@Component({
    selector: 'lsq-claim-row',
    template: `
        <div class="claim-row">
            <div class="col-12 headers">
                <span class="col-2 p label access-level-label">VIEW</span>
                <span class="col-2 p label access-level-label">EDIT</span>
                <span class="col-8 p label">{{ claimName }}</span>
            </div>
            <div class="divider"></div>
            <div class="col-12 claim-description">
                <div class="col-4 access-level">
                    <lsq-checkbox
                        [disabled]="disabled || editClaimModel"
                        class="col-6"
                        [id]="'view' + viewClaimId[0]"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="viewClaimModel"
                        (ngModelChange)="emitChange()"
                        [centered]="true"
                    >
                    </lsq-checkbox>
                    <lsq-checkbox
                        [disabled]="disabled"
                        class="col-6"
                        [id]="'edit' + editClaimId[0]"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="editClaimModel"
                        (ngModelChange)="emitChange()"
                        [centered]="true"
                    >
                    </lsq-checkbox>
                </div>
                <div class="col-8 p body text-dark-gray">{{ claimDescription }}</div>
            </div>
        </div>
    `,
    styleUrls: ['./lsq-claim-row.component.scss']
})
export class LsqClaimRowComponent {
    @Input() public viewClaimId: DashboardClaim[];
    @Input() public viewClaimModel: boolean;
    @Input() public editClaimId: DashboardClaim[];
    @Input() public editClaimModel: boolean;
    @Input() public claimName: string;
    @Input() public claimDescription: string;
    @Input() public disabled: string;

    @Output() public claimsChange = new EventEmitter<boolean[]>();

    public emitChange(): void {
        if (this.editClaimModel) {
            this.viewClaimModel = true;
        }
        this.claimsChange.emit([this.editClaimModel, this.viewClaimModel]);
    }
}
